/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { ConversationUsageDto } from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **Any authenticated role**
 */
export const getConversationUsage = (
  oktaUserId: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ConversationUsageDto>(
    { url: `/api/${oktaUserId}/conversation-usage`, method: 'GET', signal },
    options
  );
};

export const getGetConversationUsageQueryKey = (oktaUserId: string) => {
  return [`/api/${oktaUserId}/conversation-usage`] as const;
};

export const getGetConversationUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof getConversationUsage>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationUsage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetConversationUsageQueryKey(oktaUserId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getConversationUsage>>
  > = ({ signal }) => getConversationUsage(oktaUserId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!oktaUserId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getConversationUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConversationUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConversationUsage>>
>;
export type GetConversationUsageQueryError = ErrorType<unknown>;

export function useGetConversationUsage<
  TData = Awaited<ReturnType<typeof getConversationUsage>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversationUsage>>,
          TError,
          Awaited<ReturnType<typeof getConversationUsage>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetConversationUsage<
  TData = Awaited<ReturnType<typeof getConversationUsage>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversationUsage>>,
          TError,
          Awaited<ReturnType<typeof getConversationUsage>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetConversationUsage<
  TData = Awaited<ReturnType<typeof getConversationUsage>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationUsage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetConversationUsage<
  TData = Awaited<ReturnType<typeof getConversationUsage>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationUsage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetConversationUsageQueryOptions(oktaUserId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
